import { render } from "./AboutuspageCom.vue?vue&type=template&id=0410a656&scoped=true"
import script from "./AboutuspageCom.vue?vue&type=script&lang=js"
export * from "./AboutuspageCom.vue?vue&type=script&lang=js"

import "./AboutuspageCom.vue?vue&type=style&index=0&id=0410a656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0410a656"]])

export default __exports__